import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

const ProjectTimeline = () => {
  return (
    <Paper elevation={0} sx={{ p: 2, mb: 0, borderRadius: 2, backgroundColor: '#fff', width: '100%', border: '1px solid #e0e0e0' }}> 
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2.5 }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Project Timeline</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <CalendarTodayIcon sx={{ fontSize: '1rem', color: 'text.secondary', mr: 0.5 }} />
          <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>March 2025 - June 2025</Typography>
        </Box>
      </Box>
      {/* Progress Bar Container */}
      <Box sx={{ width: '100%', height: '8px', backgroundColor: '#e0e0e0', borderRadius: '4px', overflow: 'hidden', mb: 1 }}>
        {/* Active Progress Segment */}
        <Box sx={{ width: '37.5%', backgroundColor: '#1976d2', height: '100%' }} />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 0.5, px: 0.5 }}>
        <Typography variant="caption" sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>Ideation</Typography>
        <Typography variant="caption" sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>Design</Typography>
        <Typography variant="caption" sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>Verification</Typography>
        <Typography variant="caption" sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>Validation</Typography>
      </Box>
    </Paper>
  );
};

export default ProjectTimeline;
